import { statusCategoryForId } from '@atlassian/jira-common-constants/src/status-categories.tsx';
import { STATUS_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
export const getStatusesDeprecatedValue = (fields) => {
	const { status } = fields;

	if (!status || status.value == null) return {};

	const { value } = status;

	return {
		[value.id]: {
			id: value.id,
			name: value.name,
			statusCategory: statusCategoryForId(value.statusCategory?.id),
		},
	};
};

// @ts-expect-error TODO JPX-157
const transformJiraStatusToLegacyStatus = (status) => {
	if (!status || !status.statusCategory) return null;

	const { statusCategory } = status;

	return {
		id: status.statusId,
		name: status.name || '',
		statusCategory: {
			id: Number(statusCategory.statusCategoryId),
		},
	};
};

export const transformAggStatusToLegacyField: FieldTransformer<typeof STATUS_TYPE> = (node) => {
	if (node.type !== STATUS_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformJiraStatusToLegacyStatus(node.status),
		schema: {
			configuration: null,
			items: null,
			renderer: null,
			type: STATUS_TYPE,
			custom: null,
			system: STATUS_TYPE,
		},
	};
};
